<template>
  <div class="top-focus-box">
    <div class="close" v-on:click="hideTopDom"></div>
    <ul class="focus">
      <li class="logo-item" v-on:click="goDownload">
        <img src="../../assets/images/logo.jpg"  width="100" height="100"/>
        <div class="info">
          <h3>搜狐汽车</h3>
          <p>选车困难症？戳这里</p>
        </div>
        <span   class="open" >打开</span>
      </li>
      <li v-for="item in hots" v-on:click="openAutoApp(item.item_id_str, $event)">
        <img v-bind:src="item.cover" width="150" height="100"/>
        <div class="info">
          {{item.title}}
        </div>
        <span href="#"  class="open" >打开</span>
      </li>

    </ul>
    <div class="focus-nav">
      <span class="on"></span>
      <span v-for="item in hots"></span>
    </div>
  </div>
</template>
<script>
  import Slide from '../../api/slide/slide'
  import { get } from '../../api/utils/dom'
  import CheckDir from '../../api/utils/checkDir'
  import {mapGetters} from 'vuex'
  import {openApp} from '../../api/utils/funcs'
  let slideObj = null
  let checkObj = null
  export default {
    name: 'top-hot-news',
    computed: {
      ...mapGetters(['hots'])
    },
    methods: {
      hideTopDom: function () {
        if (checkObj) {
          checkObj.removeEvents()
          checkObj = null
        }
        get('.main-content').style.paddingTop = '.3rem'
        this.$el.style.display = 'none'
      },
      openAutoApp: function (id, event) {
        event.preventDefault()
        openApp(id)
      },
      goDownload: function () {
        openApp()
      }
    },
    mounted: function () {
      let k = this
      k.$nextTick(function () {
        slideObj = new Slide({
          el: get('.focus'),
          nav: get('.focus-nav'),
          navType: 'normal',
          auto: true
        })
        checkObj = new CheckDir(function () {
          k.$el.classList.add('hide-ad')
        }, function () {
          k.$el.classList.remove('hide-ad')
        })
      })
    },
    updated: function () {
      this.$nextTick(function () {
        slideObj.resizeLayout()
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/article/top-hot-news.vue